import React from "react";

function SectionTogglerButton({ title, prev }) {
  return (
    <div className="section-toggler-button">
      {prev && <span className="section-toggler-button__pointer"> &lt;</span>}
      <span className="section-toggler-button__title">{title}</span>
      {!prev && <span className="section-toggler-button__pointer">&gt;</span>}
    </div>
  );
}

export default SectionTogglerButton;
